export const starTypes = {
  percentage: [63.45, 14.1, 10.6, 7.0, 4.6, 1.13],
  color: [0xffcc6f, 0xffd2a1, 0xfff4ea, 0xf8f7ff, 0xcad7ff, 0xaabfff],
  size: [0.7, 0.7, 1.15, 1.48, 2.0, 2.5, 3.5],
};
export const starLinksTypes = {
  percentage: [63.45, 14.1, 10.6, 7.0, 4.6, 1.13],
  color: [0xffa64d, 0xff9234, 0xffd280, 0xd1d0d6, 0x8db3ff, 0x669dff],
  size: [0.7, 0.7, 1.15, 1.48, 2.0, 2.5, 3.5],
};
